import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { CoreTextField } from 'src/components/core'
import styles from './styles'

const QuestionCountSelector = ({
  classes,
  questionCount,
  onQuestionCountChange,
}) => {
  const handleQuestionCountChange = newValue => {
    if (newValue >= 1 && newValue <= 15) {
      onQuestionCountChange(newValue)
    }
  }

  return (
    <div className={classes.numberInputContainer}>
      <Typography className={classes.numberInputLabel}>
        Number of quiz questions
      </Typography>
      <CoreTextField
        value={questionCount}
        className={classes.numberInput}
        InputProps={{
          startAdornment: (
            <div
              className={classes.inputButton}
              onClick={() => handleQuestionCountChange(questionCount - 1)}
            >
              -
            </div>
          ),
          endAdornment: (
            <div
              className={classes.inputButton}
              onClick={() => handleQuestionCountChange(questionCount + 1)}
            >
              +
            </div>
          ),
          readOnly: true,
        }}
        inputProps={{
          style: { textAlign: 'center' },
        }}
      />
    </div>
  )
}

export default withStyles(styles)(QuestionCountSelector)
